import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-lg font-bold text-white">
                韩漫大全
              </span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed">
              您的韩漫资源导航站，汇集优质韩国漫画资源，提供便捷的韩漫在线阅读入口，让寻找好漫画变得更简单。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-background-400 hover:text-white text-sm transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-background-400 hover:text-white text-sm transition-colors">
                  分类浏览
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-400 hover:text-white text-sm transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">热门分类</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/fantasy" className="text-background-400 hover:text-white text-sm transition-colors">
                  奇幻冒险
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-background-400 hover:text-white text-sm transition-colors">
                  恋爱言情
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-background-400 hover:text-white text-sm transition-colors">
                  热血动作
                </Link>
              </li>
              <li>
                <Link to="/category/thriller" className="text-background-400 hover:text-white text-sm transition-colors">
                  悬疑惊悚
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">联系我们</h4>
            <ul className="space-y-2.5 text-background-400 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@manhwa123.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-400"></i>
                <span>微信公众号：韩漫大全</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-compass-3-line text-primary-400"></i>
                <span>发现更多精彩韩漫</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            &copy; {currentYear} 韩漫大全. 保留所有权利.
          </p>
          <div className="flex items-center gap-4 text-background-500 text-xs">
            <a href="#" className="hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors">使用条款</a>
            <a href="#" className="hover:text-background-300 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}